import { render, staticRenderFns } from "./HealthrecordsList.vue?vue&type=template&id=13e9ff44&"
import script from "./HealthrecordsList.vue?vue&type=script&lang=js&"
export * from "./HealthrecordsList.vue?vue&type=script&lang=js&"
import style0 from "./HealthrecordsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports